import React, { useEffect, useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import useMobileNav from '../hooks/useMobileNav';
import useScrollToSection from '../hooks/useScrollToSection';
import axios from 'axios';
import { AuthContext } from "../context/authContext.js";
import socket from '../components/Socket'; // Uvezi socket iz socket.js

const Header = () => {
  const [predmeti, setPredmeti] = useState([]);
  const [totalNotifications, setTotalNotifications] = useState(0); // Ukupan broj svih notifikacija
  const [messageNotifications, setMessageNotifications] = useState(0); // Broj notifikacija tipa 2 (casovi)
  const [classNotifications, setClassNotifications] = useState(0); // Broj notifikacija tipa 1 (poruke)
  const { currentUser, logout } = useContext(AuthContext);

  useMobileNav();
  const handleContactClick = useScrollToSection('contact');

  useEffect(() => {
    const fetchPredmeti = async () => {
      try {
        const response = await axios.get('/api/subj/predmeti');
        setPredmeti(response.data);
      } catch (error) {
        // console.error('Greška prilikom učitavanja predmeta:', error);
      }
    };

    fetchPredmeti();
  }, []);

  // ✅ Fetch notifikacija kad se korisnik promijeni
  useEffect(() => {
    if (!currentUser) return;

    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`/api/chat/notifications/unread/${currentUser.id_korisnika}`);
        setTotalNotifications(response.data.totalUnread);
        setMessageNotifications(response.data.messageUnread);
        setClassNotifications(response.data.classUnread);
      } catch (error) {
        // console.error("Greška pri učitavanju notifikacija:", error);
      }
    };

    fetchNotifications();

    // Emituj registraciju na Socket.io
    socket.emit('register', currentUser.id_korisnika);
  }, [currentUser]);

  // ✅ Socket.io - Slušanje novih notifikacija
  useEffect(() => {
    if (!currentUser) return;

    const handleNewNotification = (notification) => {
      if (notification.receiver_id !== currentUser.id_korisnika) return;

      setTotalNotifications(prev => prev + 1);
      if (notification.tip_notifikacije === 1) {
        setMessageNotifications(prev => prev + 1);
      } else if (notification.tip_notifikacije === 2) {
        setClassNotifications(prev => prev + 1);
      }
    };

    socket.off('newNotification', handleNewNotification);
    socket.on('newNotification', handleNewNotification);

    return () => {
      socket.off('newNotification', handleNewNotification);
    };
  }, [currentUser]);

  // ✅ Funkcija koja označava sve notifikacije za časove kao pročitane
  const handleClassesClick = async () => {
    if (!currentUser) return;

    try {
      await axios.post(`/api/chat/notifications/markasread/${currentUser.id_korisnika}`);

      setTotalNotifications(prev => Math.max(prev - classNotifications, 0));
      setClassNotifications(0);
    } catch (error) {
      // console.error("Greška pri označavanju časova kao pročitanih:", error);
    }
  };
  
  useEffect(() => {
    if (!currentUser) return;

    const handleUpdateTotalNotifications = ({ removedCount }) => {
        setTotalNotifications(prev => Math.max(prev - removedCount, 0));
        setMessageNotifications(prev => Math.max(prev - removedCount, 0));
    };

    socket.on("updateTotalNotifications", handleUpdateTotalNotifications);

    return () => {
        socket.off("updateTotalNotifications", handleUpdateTotalNotifications);
    };
}, [currentUser]);

  /*
  // ✅ Funkcija koja označava sve notifikacije za poruke kao pročitane
  const handleMessagesClick = async () => {
    if (!currentUser) return;

    try {
      await axios.post('/api/chat/notifications/markAsRead', {
        receiverId: currentUser.id_korisnika,
        tip_notifikacije: 1
      });

      setTotalNotifications(prev => Math.max(prev - messageNotifications, 0));
      setMessageNotifications(0);
    } catch (error) {
      console.error("Greška pri označavanju poruka kao pročitanih:", error);
    }
  };
*/

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="container d-flex align-items-center justify-content-between headerwdth">
        <NavLink to="/" className="logo d-flex align-items-center me-auto me-lg-0">
          <img src="/assets/images/logo.png" alt="logo" />
        </NavLink>
        
        <nav id="navbar" className="navbar">
          <ul>
            {currentUser && currentUser.id_tipa === 1 && (
              <li>
                <NavLink to="/admin-dashboard">Admin</NavLink>
              </li>
            )}
            <li><NavLink to="/">Početna</NavLink></li>
            <li className="dropdown">
              <a href="predmeti">
                <span>Predmeti</span>
                <i className="bi bi-chevron-down dropdown-indicator" />
              </a>
              <ul>
                {/* prvo svi tipovi koji nisu 'obican' */}
                {Array.from(new Set(predmeti.map(p => p.naziv))) // uzimamo sve tipove
                  .filter(tipNaziv => tipNaziv !== "obican") // samo posebni
                  .map(tipNaziv => (
                    <li className="dropdown" key={tipNaziv}>
                      <a href="#proba">
                        <span>{tipNaziv.charAt(0).toUpperCase() + tipNaziv.slice(1)}</span>
                        <i className="bi bi-chevron-down dropdown-indicator" />
                      </a>
                      <ul>
                        {predmeti
                          .filter(p => p.naziv === tipNaziv) // samo predmeti tog tipa
                          .map(predmet => (
                            <li key={predmet.id_predmeta}>
                              <NavLink to={`/predmeti/${predmet.link}`} className="hide-header">
                                {predmet.naziv_predmeta}
                              </NavLink>
                            </li>
                          ))}
                      </ul>
                    </li>
                  ))
                }

                {/* sada svi obicni predmeti */}
                {predmeti
                  .filter(p => p.naziv === "obican")
                  .map(predmet => (
                    <li key={predmet.id_predmeta}>
                      <NavLink to={`/predmeti/${predmet.link}`}>
                        {predmet.naziv_predmeta}
                      </NavLink>
                    </li>
                  ))
                }
              </ul>
            </li>

            {!currentUser && (
              <li><NavLink to="/postani-profesor">Postani profesor</NavLink></li>
            )}
            <li><NavLink to="/#contact" className='disable-active' onClick={handleContactClick}>Kontakt</NavLink></li>
          </ul>
        </nav>

        {currentUser && (
          <div className="dropdown text-end">
            <a href="#proba" className="d-block link-body-emphasis text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              {currentUser.img ? (
                <img src={currentUser.img} alt="Profile" width={32} height={32} className="rounded-circle" />
              ) : (
                <img src="/assets/images/student-logo.png" alt="Default" width={32} height={32} className="rounded-circle" />
              )}
              {totalNotifications > 0 && (
                <span className="notification-badge">{totalNotifications}</span>
              )} {/* Ukupan broj notifikacija */}
            </a>
            <ul className="dropdown-menu text-small">
              <li>
                <NavLink to="/dashboard" className="dropdown-item" onClick={handleClassesClick}>
                  Časovi
                  {classNotifications > 0 && (
                    <span className="notification-badge">{classNotifications}</span>
                  )} {/* Broj notifikacija za časove */}
                </NavLink>
              </li>
              <li>
                <NavLink to="/poruke" className="dropdown-item"  >
                  Poruke
                  {messageNotifications > 0 && (
                    <span className="notification-badge">{messageNotifications}</span>
                  )} {/* Broj notifikacija za poruke */}
                </NavLink>
              </li>
              <li><NavLink to="/podesavanja" className="dropdown-item">Podešavanja</NavLink></li>
              <li><hr className="dropdown-divider" /></li>
              <li><a className="dropdown-item" href="#proba" onClick={logout}>Odjavi se</a></li>
            </ul>
          </div>
        )}

        {!currentUser && <NavLink className="btn-login" to="/login">Prijava</NavLink>}
        <i className="mobile-nav-toggle mobile-nav-show bi bi-list" />
        <i className="mobile-nav-toggle mobile-nav-hide d-none bi bi-x" />
      </div>
    </header>
  );
};

export default Header;
